const galleryRoutes = [
  {
    path: '/gallery/category',
    name: 'gallery-category-list',
    component: () => import('@/views/gallery/gallery-category-list')
  },
  {
    path: '/gallery/category/:categoryId/photo',
    name: 'gallery-photo-list',
    component: () => import('@/views/gallery/gallery-photo-list')
  },
  {
    path: '/gallery/submission',
    name: 'gallery-submission',
    component: () => import('@/views/gallery/gallery-submission')
  }
]

export default galleryRoutes
